import React from 'react';

import NonFSIndex from "@dndComponents/NonFSIndex";

export default function EnvironmentIndex() {
  return (
    <NonFSIndex
      data_type="environment"
    />
  );
}
